import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#0A0A0A] text-white px-6 md:px-12 pt-24 pb-10"
    >
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 pb-16 border-b border-white/15">
          <div className="md:col-span-5">
            <img
              src="/jay-ink-wordmark-white.png"
              alt="JAY-INK Academy"
              draggable={false}
              className="w-full max-w-[280px] md:max-w-[340px] h-auto select-none"
            />
            <p className="overline mt-6 text-white/60">Sydney — Paddington &amp; Bondi Beach</p>
          </div>
          <div className="md:col-span-3">
            <div className="overline mb-4 text-white/60">Studios</div>
            <ul className="space-y-2 text-sm font-light text-white/85">
              <li>64 William Street, Paddington</li>
              <li>177 Glenayr Avenue, Bondi Beach</li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline mb-4 text-white/60">Contact</div>
            <ul className="space-y-2 text-sm font-light">
              <li><a href="mailto:jayinkacademy@gmail.com" className="hover:opacity-60">Email</a></li>
              <li><a href="tel:+61415556026" className="hover:opacity-60">+61 415 556 026</a></li>
              <li>
                <a
                  href="https://instagram.com/jayink__academy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-60"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="overline mb-4 text-white/60">Navigate</div>
            <ul className="space-y-2 text-sm font-light">
              <li><a href="#booking" className="hover:opacity-60">Booking</a></li>
              <li><a href="#portfolio" className="hover:opacity-60">Portfolio</a></li>
              <li><a href="#artists" className="hover:opacity-60">Artists</a></li>
              <li>
                <Link
                  to="/admin"
                  data-testid="footer-admin-link"
                  className="hover:opacity-60"
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mt-10 gap-4 text-[10px] tracking-[0.3em] uppercase text-white/50">
          <div>© {year} JAY-INK Academy. All rights reserved.</div>
          <div>Fine line · Micro-realism · Black &amp; Grey</div>
        </div>
      </div>
    </footer>
  );
}
